import { createChooseJobContainer } from './container'
import { ChooseJobsUI } from './ui/choose-jobs'

export const ChooseJobs = createChooseJobContainer(ChooseJobsUI)
